import { User } from "oidc-client";
import {
  CadmakersApp,
  RoleClaimReader,
  RoleClaimKey,
  AuthRole,
  CMKAppRole,
  CMBuilderAppRole,
  CMExeAppRole
} from "@cadmakers/auth";
import { Role } from "../Constants/roleEnums";

interface IRoleService {
  getBestRoleStringForUser(user: User | undefined): string;
  getBestRoleForUser(user: User | undefined): Role | null;
  isUserInRole(user: User | undefined, role: Role): boolean;
}

class RoleService implements IRoleService {
  getBestRoleStringForUser(user: User | undefined): string {
    const bestRole = this.getBestRoleForUser(user);
    switch (bestRole) {
      case Role.CMAdmin:
        return "CM Admin";
      case Role.Admin:
        return "Admin";
      default:
        return "User";
    }
  }

  getBestRoleForUser(user: User | undefined): Role | null {
    if (this.isUserInRole(user, Role.CMAdmin)) {
      return Role.CMAdmin;
    }
    if (this.isUserInRole(user, Role.Admin)) {
      return Role.Admin;
    }
    return null;
  }

  /* eslint class-methods-use-this: ["error", { "exceptMethods": ["isUserInRole"] }] */
  isUserInRole(user: User | undefined, role: Role): boolean {
    if (!user) {
      return false;
    }

    const userRoles = user.profile[RoleClaimKey];
    const reader = new RoleClaimReader(userRoles);

    switch (role) {
      case Role.Admin: {
        return (
          reader.getRoles(CadmakersApp.Auth).includes(AuthRole.CORE_Admin) ||
          reader.getRoles(CadmakersApp.Auth).includes(AuthRole.CMAdmin) ||
          reader.getRoles(CadmakersApp.Knowledge).includes(CMKAppRole.CMK_Admin) ||
          reader.getRoles(CadmakersApp.Exe).includes(CMExeAppRole.EXE_Admin) ||
          reader.getRoles(CadmakersApp.Builder).includes(CMBuilderAppRole.CMB_Admin)
        );
      }
      case Role.CMAdmin: {
        return reader.getRoles(CadmakersApp.Auth).includes(AuthRole.CMAdmin);
      }
      default: {
        return false;
      }
    }
  }
}

export const roleService: IRoleService = new RoleService();
